module.exports = __webpack_public_path__ + "img/electronic_electric_reserved.3e750927.svg";